import { Icon, type IconProps } from './Icon';

export const TrainedIcon = (props: IconProps) => (
  <Icon {...props}>assistant</Icon>
);
export const UntrainedIcon = (props: IconProps) => (
  <Icon {...props}>live_help</Icon>
);

export const MissingIcon = (props: IconProps) => (
  <Icon {...props}>check_box_outline_blank</Icon>
);

export const DownloadIcon = (props: IconProps) => (
  <Icon {...props}>cloud_download</Icon>
);
export const SendMessageIcon = (props: IconProps) => (
  <Icon {...props}>send</Icon>
);
export const TemplatesIcon = (props: IconProps) => (
  <Icon {...props}>more_vert</Icon>
);
export const NewStuffIcon = (props: IconProps) => (
  <Icon {...props}>fiber_new</Icon>
);

export const PopularIcon = (props: IconProps) => (
  <Icon {...props}>trending_up</Icon>
);
export const BundleIcon = (props: IconProps) => (
  <Icon {...props}>group_work</Icon>
);
export const PurchasesIcon = (props: IconProps) => (
  <Icon {...props}>account_balance_wallet</Icon>
);

export const AppIcon = (props: IconProps) => <Icon {...props}>extension</Icon>;

export const NoteAlertIcon = (props: IconProps) => (
  <Icon {...props}>error</Icon>
);
export const WarningAlertIcon = (props: IconProps) => (
  <Icon {...props}>warning</Icon>
);

export const SupportAggentIcon = (props: IconProps) => (
  <Icon {...props}>support_agent</Icon>
);
export const AddressIcon = (props: IconProps) => (
  <Icon {...props}>location_on</Icon>
);
export const HoursIcon = (props: IconProps) => (
  <Icon {...props}>access_time</Icon>
);
export const ParkingIcon = (props: IconProps) => (
  <Icon {...props}>directions_car</Icon>
);
export const PricingIcon = (props: IconProps) => (
  <Icon {...props}>attach_money</Icon>
);
export const ReservationsIcon = (props: IconProps) => (
  <Icon {...props}>event</Icon>
);
export const AttireIcon = (props: IconProps) => (
  <Icon {...props}>accessibility</Icon>
);
export const KidsIcon = (props: IconProps) => (
  <Icon {...props}>child_friendly</Icon>
);
export const AlcoholIcon = (props: IconProps) => (
  <Icon {...props}>local_bar</Icon>
);
export const ChatIcon = (props: IconProps) => (
  <Icon {...props}>chat_bubble</Icon>
);
export const UserIcon = (props: IconProps) => <Icon {...props}>person</Icon>;
export const BroadcastIcon = (props: IconProps) => (
  <Icon {...props}>announcement</Icon>
);
export const AssignIcon = (props: IconProps) => (
  <Icon {...props}>person_add</Icon>
);
export const RemindIcon = (props: IconProps) => (
  <Icon {...props}>alarm_on</Icon>
);
export const MarkSpamIcon = (props: IconProps) => <Icon {...props}>block</Icon>;
export const NewMessageIcon = (props: IconProps) => (
  <Icon {...props}>create</Icon>
);
export const MessagesViewIcon = (props: IconProps) => (
  <Icon {...props}>message</Icon>
);
export const StarIcon = (props: IconProps) => <Icon {...props}>star</Icon>;
export const ReportsViewIcon = (props: IconProps) => (
  <Icon {...props}>insert_chart</Icon>
);
export const SettingsViewIcon = (props: IconProps) => (
  <Icon {...props}>settings</Icon>
);
export const ContactsViewIcon = (props: IconProps) => (
  <Icon {...props}>people</Icon>
);
export const AppsViewIcon = (props: IconProps) => (
  <Icon {...props}>extension</Icon>
);
export const AttachIcon = (props: IconProps) => (
  <Icon {...props}>attach_file</Icon>
);
export const ImageIcon = (props: IconProps) => <Icon {...props}>photo</Icon>;
export const SurveyIcon = (props: IconProps) => (
  <Icon {...props}>live_help</Icon>
);
export const UploadIcon = (props: IconProps) => (
  <Icon {...props}>cloud_upload</Icon>
);
export const FileIcon = (props: IconProps) => (
  // @ts-expect-error FIXME: No overload matches this call.
  <Icon sx={{ transform: 'rotate(-90deg)' }} {...props}>
    note
  </Icon>
);

export const ReviewIcon = (props: IconProps) => (
  <Icon {...props}>rate_review</Icon>
);
export const LoyaltyIcon = (props: IconProps) => <Icon {...props}>update</Icon>;
export const ChannelsIcon = (props: IconProps) => (
  <Icon {...props}>swap_horiz</Icon>
);
export const AssistantFactIcon = (props: IconProps) => (
  <Icon {...props}>language</Icon>
);
export const AssistantQuestionIcon = (props: IconProps) => (
  <Icon {...props}>help</Icon>
);
export const AssistantReplyIcon = (props: IconProps) => (
  <Icon {...props}>reply_all</Icon>
);
export const VoicemailIcon = (props: IconProps) => (
  <Icon {...props}>perm_phone_msg</Icon>
);
export const WelcomeMessageIcon = (props: IconProps) => (
  <Icon {...props}>question_answer</Icon>
);

export const ExpandIcon = (props: IconProps) => (
  <Icon {...props}>expand_more</Icon>
);
export const CollapseIcon = (props: IconProps) => (
  <Icon {...props}>expand_less</Icon>
);
export const LibraryIcon = (props: IconProps) => (
  <Icon {...props}>local_library</Icon>
);
export const ToggleLeftIcon = (props: IconProps) => (
  <Icon {...props}>chevron_left</Icon>
);
export const ToggleRightIcon = (props: IconProps) => (
  <Icon {...props}>chevron_right</Icon>
);
export const DoneIcon = (props: IconProps) => (
  <Icon {...props}>check_circle</Icon>
);
export const GoingIcon = (props: IconProps) => (
  <Icon {...props}>all_inclusive</Icon>
);
export const HappyFaceIcon = (props: IconProps) => (
  <Icon {...props}>sentiment_very_satisfied</Icon>
);

export const MissedCallIcon = (props: IconProps) => (
  <Icon {...props}>call_missed</Icon>
);
export const TimeIcon = (props: IconProps) => <Icon {...props}>watch</Icon>;
export const ReportsIcon = (props: IconProps) => (
  <Icon {...props}>insert_chart</Icon>
);
export const DelegateIcon = (props: IconProps) => (
  <Icon {...props}>delegate</Icon>
);
export const PlatformIcon = (props: IconProps) => (
  <Icon {...props}>device_hub</Icon>
);
export const OffersIcon = (props: IconProps) => (
  <Icon {...props}>local_offer</Icon>
);
export const NotificationsIcon = (props: IconProps) => (
  <Icon {...props}>sms_failed</Icon>
);
export const RemoveIcon = (props: IconProps) => (
  <Icon {...props}>remove_circle_outline</Icon>
);

export const AddIcon = (props: IconProps) => (
  <Icon {...props}>add_circle_outline</Icon>
);
export const PlusIcon = (props: IconProps) => <Icon {...props}>add</Icon>;
export const RadioOffIcon = (props: IconProps) => (
  <Icon {...props}>radio_button_unchecked</Icon>
);

export const RadioOnIcon = (props: IconProps) => (
  <Icon {...props}>radio_button_checked</Icon>
);

export const CheckBoxOnIcon = (props: IconProps) => (
  <Icon {...props}>check_box</Icon>
);
export const CheckBoxOffIcon = (props: IconProps) => (
  <Icon {...props}>check_box_outline_blank</Icon>
);

export const CheckIcon = (props: IconProps) => <Icon {...props}>check</Icon>;
export const DeleteIcon = (props: IconProps) => <Icon {...props}>delete</Icon>;
export const EditIcon = (props: IconProps) => <Icon {...props}>edit</Icon>;
export const ErrorIcon = (props: IconProps) => <Icon {...props}>error</Icon>;
export const EventIcon = (props: IconProps) => <Icon {...props}>event</Icon>;
export const LinkIcon = (props: IconProps) => <Icon {...props}>link</Icon>;
export const ThumbDownIcon = (props: IconProps) => (
  <Icon {...props}>thumb_down</Icon>
);
export const ThumbUpIcon = (props: IconProps) => (
  <Icon {...props}>thumb_up</Icon>
);
export const ContactIcon = (props: IconProps) => (
  <Icon {...props}>contact_phone</Icon>
);
export const ReviewStarsIcon = (props: IconProps) => (
  <Icon {...props}>stars</Icon>
);
export const EmailIcon = (props: IconProps) => <Icon {...props}>email</Icon>;
export const BackArrowIcon = (props: IconProps) => (
  <Icon {...props}>arrow_back</Icon>
);

export const FaceIcon = (props: IconProps) => <Icon {...props}>face</Icon>;

export const PhoneCallbackIcon = (props: IconProps) => (
  <Icon {...props}>phone_callback</Icon>
);

export const PhoneIcon = (props: IconProps) => <Icon {...props}>phone</Icon>;
export const SearchIcon = (props: IconProps) => <Icon {...props}>search</Icon>;

export const RefreshIcon = (props: IconProps) => (
  <Icon {...props}>refresh</Icon>
);
export const CalendarIcon = (props: IconProps) => (
  <Icon {...props}>calendar_today</Icon>
);
export const GroupIcon = (props: IconProps) => <Icon {...props}>group</Icon>;
export const StorefrontIcon = (props: IconProps) => (
  <Icon {...props}>storefront</Icon>
);
export const ArrowForwardIcon = (props: IconProps) => (
  <Icon {...props}>arrow_forward</Icon>
);
